const setCookie = params => {
  let content =
    params.name && params.content ? `${params.name}=${params.content};` : "";
  let secure = params.secure ? `Secure;` : "";
  const ONE_MONTH = 2592000;

  let expiration = params.expiration
    ? `max-age=${params.expiration}`
    : `max-age=${ONE_MONTH}`;

  if (content || secure) {
    document.cookie = `${content}${secure}${expiration}`;
  }
};

const getCookie = name => {
  let content = null;

  if (name && document.cookie) {
    const cookie = document.cookie
      .split("; ")
      .find(item => item.startsWith(name));
    if (cookie) {
      content = cookie.split("=")[1];
    }
  }

  return content;
};

export { getCookie, setCookie };
